'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'GoogleTagManager',
    props: ['type'],
    mounted: function mounted() {
        var scriptEl = document.createElement('script');
        if (this.type === 'left') {
            var textnode = document.createTextNode('googletag.cmd.push(function() { googletag.display(\'div-gpt-ad-1621131-2\'); });');
            scriptEl.appendChild(textnode);
            document.getElementById('div-gpt-ad-1621131-2').appendChild(scriptEl);
        } else if (this.type === 'right') {
            var _textnode = document.createTextNode('googletag.cmd.push(function() { googletag.display(\'div-gpt-ad-1621131-3\'); });');
            scriptEl.appendChild(_textnode);
            document.getElementById('div-gpt-ad-1621131-3').appendChild(scriptEl);
        } else {
            var _textnode2 = document.createTextNode('googletag.cmd.push(function() { googletag.display(\'div-gpt-ad-1621131-5\'); });');
            scriptEl.appendChild(_textnode2);
            document.getElementById('div-gpt-ad-1621131-5').appendChild(scriptEl);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/GoogleTagManager.vue
// module id = XxdM
// module chunks = 1